module.exports = __webpack_public_path__ + "static/img/defaultAvatar.fbd95c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/defaultAvatar.png
// module id = 7tkr
// module chunks = 22